import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col } from 'antd';
import { customFormatclass, customClassSummary } from 'Components/GDTable/GDCustomFormat/GDCustomFormat';
import GDAccountNumberCell from 'Components/GDTable/GDAccountNumberCell/GDAccountNumberCell';

import './ImageData.scss';
import 'antd/dist/reset.css';

const ImageData = (props) => {
  return (
    <div className="image-data-results">
      <Row>
        <div className="data-title">Image Data</div>
        {props.dataPanel.map((column) => {
          let valueClass;
          if ((column.displayType === 'CURRENCY' || column.displayType === 'NEGATIVE_NUMBER') && Number.parseFloat(props.dataContent[column.columnKey].value === undefined ? props.dataContent[column.columnKey] : props.dataContent[column.columnKey].value) < 0) {
            valueClass = customFormatclass(customClassSummary, column.displayType);
          } else if (Number.parseFloat(props.dataContent[column.columnKey]) < 0) {
            valueClass = customFormatclass(customClassSummary, column.displayType);
          }

          const handlePrecision = (amount, precision) => {
            if (amount !== undefined && amount !== null) {
              const arr = `${amount}`.split('.');
              return arr.length > 1
                ? `${arr[0] <= 0 ? arr[0] * -1 : arr[0]}.${arr[1].length === 1 ? `${arr[1]}0` : arr[1].substr(0, precision)}`
                : `${amount <= 0 ? amount * -1 : amount}.00`;
            }
            return '--';
          };
          const handleEmptyValues = (dataVal) => {
            if (dataVal === null || dataVal === undefined || dataVal === '') { return '--'; } else { return dataVal; }
          };

          let value;
          if (column.displayType === 'CURRENCY') {
            value = handlePrecision(props.dataContent[column.columnKey].value === undefined ? props.dataContent[column.columnKey] : props.dataContent[column.columnKey].value, 2);
          } else if (column.displayType === 'STRING') {
            value = handleEmptyValues(props.dataContent[column.columnKey]);
          } else if (column.displayType === 'NEGATIVE_NUMBER') {
            value = handlePrecision(props.dataContent[column.columnKey], 2);
          } else if (column.displayType === 'ACCOUNTNUMBER') {
            value = (
              <GDAccountNumberCell
                accountNumber={(props.dataContent[column.columnKey])}
                token={this.props.dataContent[column.secondaryColumnKey === undefined ? 'globalToken' : column.secondaryColumnKey]}
              />
            );
          } else if (column.displayType === 'INDICATOR') {
            value = props.dataContent[column.columnKey] === '1' ? 'Yes' : 'No';
          } else if (column.displayType === 'DATE') {
            const date = moment(props.dataContent[column.columnKey]);
            value = date.format(props.dateFormat);
          } else {
            value = props.dataContent[column.columnKey];
          }


          return (
            <Col key={column.columnKey} span={12}>
              <div  className="image-data-results-list">
                <div className="image-data-results-list-item">
                  <div className="image-data-results-list-item-wrapper">
                    <span className="image-data-results-list-item-label">
                      {column.name}

                    </span>
                    <span className="image-data-results-list-item-amount">
                      {' '}
                      {value}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

ImageData.propTypes = {
  title: PropTypes.string,
  dataPanel: PropTypes.array,
  dataContent: PropTypes.array,
};

ImageData.defaultProps = {
  title: '',
  dataPanel: {},
  dataContent: {},
};
export default ImageData;
